import PopupSectionTitle from "./PopupSectionTitle";
import SlotEventCardList from "./SlotEventCardList";

export default ({ title, events, onClickEvent }) => {
  return (
    <div className="calendar-day-events-list">
      <PopupSectionTitle title={title} />
      {events.length > 0 && (
        <div className="calendar-day-events-list-list">
          {events.map((event, index) => {
            return (
              <SlotEventCardList
                key={index}
                event={event}
                onClickEvent={() => onClickEvent(event)}
              />
            );
          })}
        </div>
      )}
      {events.length === 0 && (
        <div className="calendar-day-events-list-list">
          <span>No existen citas.</span>
        </div>
      )}
    </div>
  );
};
